<template>
  <div class="px-2 -mx-2 bg-gray-100 dark:bg-transparent sm:px-5 sm:-mx-5">
    <div class="grid py-16 mx-auto space-y-16 max-w-site-max-w md:grid-cols-2 sm:space-y-0">
      <div class="flex flex-col items-start mx-2 md:mx-6 md:py-16">
        <div class="max-w-112">
          <p class="mb-4 text-3xl font-bold text-primary-900 dark:text-gray-300">
            {{ $t('heading') }}
          </p>
          <p class="text-xl font-light text-primary-900 dark:text-gray-300">
            {{ $t('body') }}
          </p>
        </div>
      </div>
      <div class="flex flex-col items-center">
        <div class="relative max-w-64 sm:max-w-96">
          <template v-if="isLocaleEnglish">
            <img
              svg-inline
              src="@/assets/images/landing/timing-box-en.png"
              class="w-full h-full rounded-lg dark:hidden shadow-200"
            />
            <img
              svg-inline
              src="@/assets/images/landing/timing-box-dark-en.png"
              class="hidden w-full h-full border border-gray-900 rounded-lg dark:block"
            />
          </template>
          <template v-else>
            <img
              svg-inline
              src="@/assets/images/landing/timing-box-es.png"
              class="w-full h-full rounded-lg dark:hidden shadow-200"
            />
            <img
              svg-inline
              src="@/assets/images/landing/timing-box-dark-es.png"
              class="hidden w-full h-full border border-gray-900 rounded-lg dark:block"
            />
          </template>
          <div
            class="absolute top-0 left-0 hidden w-16 h-16 mt-24 -ml-8 rounded-full pink-gradient z-1 sm:block"
          />
          <svg xmlns="http://www.w3.org/2000/svg" width="148" height="175" viewBox="0 0 148 175" v-bind:svg-inline="''" v-bind:src="'@/assets/images/landing/coach.svg'" v-bind:class="'absolute bottom-0 right-0 w-24 h-24 -mb-4 -mr-16 sm:w-48 sm:h-48 sm:-mb-8 sm:-mr-32'"><g fill="none" fill-rule="evenodd"><path fill="#67D1E1" stroke="#67D1E1" stroke-width=".643" d="M129.323 42.183H31.055c-7.747 0-14.095 6.058-14.337 13.682l-3.306 104.163c-.247 7.796 5.971 14.314 13.89 14.558.149.004.298.007.447.007H132.63c7.922 0 14.344-6.324 14.344-14.124 0-.147-.002-.294-.007-.441L143.66 55.865c-.242-7.624-6.59-13.682-14.337-13.682z"/><g fill-rule="nonzero"><path fill="#FFF" stroke="#FFF" stroke-linejoin="round" stroke-width="1.26" d="M51.799 128.985c-2.476 0-4.483 1.976-4.483 4.414h0v10.298H51.8v-5.885c1.65 0 2.647-2.942 2.988-8.827H51.8z"/><path fill="#DDDBEA" d="M48.811 133.399h-1.494v4.414h1.494zm5.976-4.414c-2.475 0-4.482 1.976-4.482 4.414v10.298h2.988l-.001-6.136c.468.163.97.251 1.495.251 2.476 0 4.483-1.976 4.483-4.413 0-2.438-2.007-4.414-4.483-4.414z"/><path fill="#DDDBEA" stroke="#DDDBEA" stroke-linejoin="round" stroke-width="1.26" d="M54.787 128.985c-2.475 0-4.482 1.976-4.482 4.414h0v10.298h2.988l-.001-6.136c.468.163.97.251 1.495.251 2.476 0 4.483-1.976 4.483-4.413 0-2.438-2.007-4.414-4.483-4.414z"/></g><path stroke="#DDDBEA" stroke-dasharray="1.26" stroke-linecap="round" stroke-width="1.26" d="M146.145 94.909c-53.81 23.103-85.258 33.971-94.346 32.605-9.087-1.367-21.337-11.42-36.748-30.16"/><g fill-rule="nonzero"><path fill="#DDDBEA" d="M38.18 37.416C39.274 16.571 51.38.213 80.176 1.321c.346.013 24.57 1.28 24.917 1.298 29.255 1.533 40.138 19.253 39.032 40.35L38.181 37.416z"/><path fill="#F7F7FF" stroke="#F7F7FF" stroke-width=".63" d="M38.18 37.416C39.274 16.571 51.38.213 80.176 1.321c.347.013.057-.018.405 0 29.256 1.533 40.137 19.253 39.032 40.349L38.18 37.416z"/><path fill="#DDDBEA" d="M144.124 42.969l-140.42-7.36c-1.562-.08-2.892 1.1-2.973 2.638l-.093 1.777c-.08 1.538 1.12 2.85 2.681 2.933l137.593 7.21c1.561.082 2.892-1.098 2.972-2.635l.24-4.562z"/></g><g transform="matrix(-1 0 0 1 130.992 78.963)"><rect width="38.849" height="82.388" fill="#ACAAC3" fill-rule="nonzero" rx="5.04"/><path stroke="#DDDBEA" stroke-linecap="round" stroke-width="2.52" d="M12.701 7.356v57.378M24.654 7.356v22.068"/></g><g fill-rule="nonzero"><path fill="#67D1E1" d="M138.804 107.523l-1.693 19.35c-.096 1.099-1.05 1.913-2.133 1.818-6.343-.555-11.027-6.227-10.463-12.67.563-6.44 6.161-11.213 12.504-10.658 1.082.095 1.88 1.061 1.785 2.16z"/><path fill="#FFF" fill-opacity=".2" d="M138.804 107.523l-1.693 19.35c-.096 1.099-1.05 1.913-2.133 1.818-6.343-.555-11.027-6.227-10.463-12.67.563-6.44 6.161-11.213 12.504-10.658 1.082.095 1.88 1.061 1.785 2.16z"/></g><g transform="matrix(-1 0 0 1 87 67)"><path stroke="#00292B" stroke-linecap="round" stroke-linejoin="round" stroke-width="3.78" d="M38.61 23.52a18.347 18.347 0 01-13.507 5.88c-5.37 0-10.196-2.269-13.519-5.874"/><ellipse cx="7.048" cy="2.94" fill="#00292B" rx="3.024" ry="2.94"/><ellipse cx="43.336" cy="2.94" fill="#00292B" rx="3.024" ry="2.94"/></g></g></svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import componentI18n from '@/i18n/componentI18n';
import { mapGetters } from 'vuex';

export default {
  name: 'TimeboxedFlow',
  ...componentI18n('views.landing.timeboxed_flow'),
  computed: {
    ...mapGetters(['locale']),
    isLocaleEnglish() {
      return this.locale === 'en';
    }
  }
};
</script>

<style lang="scss">
.pink-gradient {
  background-image: linear-gradient(to bottom, #ec82d7, #e02b52);
}
</style>
